import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

Vue.use(Vuex);

const Store = new Vuex.Store({
    modules,
    actions,
    mutations,
    getters,
    state,
})

export default Store;
